import apiRequest from './apiRequest';

/**
 * One ingest event for POST /metrics/events (user-api).
 * Mirrors TrackEventRuntimeInput — validated server-side against the Metrics catalog.
 */
export type MetricsEventInput = {
  eventName: string;
  eventSource: string;
  accessorID?: string;
  /** Maps from authStore workingSessionID on the client. */
  sessionID?: string;
  organizationID?: string;
  interface?: 'ui' | 'programmatic' | 'plugin';
  app?: string;
  client?: string;
  clientVersion?: string;
  endpoint?: string;
  httpStatus?: number;
  creditsSpent?: number;
  experiments?: Record<string, string>;
  assetOrigin?: 'self' | 'teammate';
  createdByUserID?: string;
  properties?: Record<string, unknown>;
};

export type PostMetricsEventsBody = {
  events: MetricsEventInput[];
};

export type PostMetricsEventsResponse = {
  eventIDs: string[];
};

/**
 * POST /metrics/events — batch-shaped ingest (v1 allows at most 1 event).
 * Anonymous and authenticated callers are both supported via cookies.
 */
export default async function postMetricsEvents(body: PostMetricsEventsBody) {
  return apiRequest<PostMetricsEventsResponse>('user', '/metrics/events', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
